// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { PageInfoFragment } from '../../../../../graphql/fragments/pageInfo.fragment.generated';
import { Cashflows_CashflowFragment } from '../../../../../modules/cashflows/CashflowDrawer/graphql/Cashflows.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../../graphql/fragments/pageInfo.fragment.generated';
import { Cashflows_CashflowFragmentDoc } from '../../../../../modules/cashflows/CashflowDrawer/graphql/Cashflows.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CashflowsQueryVariables = Types.Exact<{
  where: Types.CashflowWhereInput;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
  orderBy?: Types.InputMaybe<Array<Types.CashflowOrder> | Types.CashflowOrder>;
}>;


export type CashflowsQuery = { __typename?: 'Query', paginatedData: { __typename?: 'CashflowConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'CashflowEdge', node?: (
        { __typename?: 'Cashflow' }
        & Cashflows_CashflowFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    Cashflows: 'Cashflows' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const CashflowsDocument = gql`
    query Cashflows($where: CashflowWhereInput!, $first: Int!, $after: Cursor, $orderBy: [CashflowOrder!]) {
  paginatedData: cashflows(
    where: $where
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...Cashflows_Cashflow
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${Cashflows_CashflowFragmentDoc}`;

/**
 * __useCashflowsQuery__
 *
 * To run a query within a React component, call `useCashflowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashflowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashflowsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCashflowsQuery(baseOptions: Apollo.QueryHookOptions<CashflowsQuery, CashflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashflowsQuery, CashflowsQueryVariables>(CashflowsDocument, withFetchPolicyContext(options));
      }
export function useCashflowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashflowsQuery, CashflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashflowsQuery, CashflowsQueryVariables>(CashflowsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useCashflowsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CashflowsQuery, CashflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CashflowsQuery, CashflowsQueryVariables>(CashflowsDocument, withFetchPolicyContext(options));
        }
export type CashflowsQueryHookResult = ReturnType<typeof useCashflowsQuery>;
export type CashflowsLazyQueryHookResult = ReturnType<typeof useCashflowsLazyQuery>;
export type CashflowsSuspenseQueryHookResult = ReturnType<typeof useCashflowsSuspenseQuery>;
export type CashflowsQueryResult = Apollo.QueryResult<CashflowsQuery, CashflowsQueryVariables>;